const cataloguePage = ('.post-type-archive-catalogue');

if (cataloguePage) {
    const filters = $('.filterDropdown--label');
    const filterBtn = $('.filters--btn--wrapper');
    const form = $('#sidebarFilterForm');
    const clearFilters = $('.clearAllFilters')
    const sortBy = $('#orderby');
    const filtersClose = $('.sidebar--filters__close');
    const openFilters = $('#cta_archive_filters__filters-v2');
    const mobileFilters = $('.product_page--filters-container');
    const mobileFiltersBtn = $('.cta_archive_filters-v2');
    let headerHeight = null;
    
    filters.on('click', function() {
        const filter = $(this);
        filter.toggleClass('active');
        filter.next().slideToggle();
    });

    function setPreSelectedFilters(values, key) {
        const filters = $('.filterDropdown--label[data-filter="' + key + '"]');
        values.forEach(value => {
            filters.next().find('.tpfl-check[value="' + value + '"]').prop('checked', true);
        });
    }
    
    // once the page has loaded, count the number of checked items in each filter and update the count
    document.addEventListener('DOMContentLoaded', function() {
        headerHeight = $('header').height();
        mobileFilters.find('.sidebar--filters').css('height', 'calc(100dvh - ' + headerHeight + 'px)');

        // if page is not scroll top when loaded, add padding to the top of the filters
        if ($(window).scrollTop() > 50) {
            mobileFilters.find('.sidebar--filters').css('top', headerHeight);
        }

        // on scroll add header height to the top of the filters as padding
        $(window).scroll(function() {
            if ($(window).scrollTop() > 50) {
                mobileFilters.find('.sidebar--filters').css('top', headerHeight);
            } else {
                mobileFilters.find('.sidebar--filters').css('top', 0);
            }
        });

        // if url has query string, check the boxes
        const urlParams = new URLSearchParams(window.location.search);
        const filterMappings = {
            brand: 'brand',
            pump: 'pump',
            industry: 'industry',
            application: 'application',
            rate: 'rate',
            flow: 'flow',
            head: 'head',
            temp: 'temp'
        };
        
        Object.keys(filterMappings).forEach(key => {
            if (urlParams.has(key)) {
                const values = urlParams.get(key).split(',');
                setPreSelectedFilters(values, key);
            }
        });

        if (urlParams.has('sort')) {
            const value = urlParams.get('sort');
            // set the selected value in the dropdown
            sortBy.val(value);
        }

        // if no params, hide the clear filters button
        if (!urlParams.has('brand') && !urlParams.has('pump') && !urlParams.has('industry') && !urlParams.has('application') && !urlParams.has('rate') && !urlParams.has('flow') && !urlParams.has('head') && !urlParams.has('temp')) {
            url = window.location.pathname;
            if (url.indexOf('/categories/') == -1) {
                clearFilters.hide();
            }
        }
    
        filters.each(function() {
            const options = $(this).next().find('.tpfl-check');
            const count = options.filter(':checked').length;
            if (count > 0) {
                $(this).find('.filterDropdown--label--count').text(count);
            } else {
                $(this).find('.filterDropdown--label--count').parent().hide();
            }
        });

        // checkbox allows just 1 input to be checked within group, for pump type filter

        $('.filterDropdown--option--pump input[type="checkbox"]').on('change', function(){
            if($(this).is(':checked')){
              $('.filterDropdown--option--pump input[type="checkbox"]').not(this).prop('checked', false);
            }
        });
        
        // if checkboxes have been updated/changed, change update button to blue styling, if reverted to original checked states go back to grey

        let initial_checked_states = {};
        $('.tpfl-check').each(function() {
            initial_checked_states[$(this).attr('id')] = $(this).prop('checked');
        });

        function checkForChanges() {
            let checked_have_changed = false;
            $('.tpfl-check').each(function() {
                if($(this).prop('checked') !== initial_checked_states[$(this).attr('id')]){
                    checked_have_changed = true;
                    return false;
                }
            });
    
            if(checked_have_changed){
                $('.filters--btn--wrapper .btn--filters').addClass('active');
            }
            else{
                $('.filters--btn--wrapper .btn--filters').removeClass('active');
            }
        }
    
        $('.tpfl-check').on('change', function() {
            checkForChanges();
        });
    
        $('.tpfl-check').on('change', function() {
            const filter = $(this).closest('.filterDropdown').find('.filterDropdown--label');
            const count = filter.next().find('.tpfl-check').filter(':checked').length;
            if (count > 0) {               
                filter.find('.filterDropdown--label--count').text(count);
                if (!filter.find('.filterDropdown--label--count').parent().is(':visible')) {
                    console.log('show', filter.find('.filterDropdown--label--count').parent());
                    filter.find('.filterDropdown--label--count').parent().show();
                }
            } else {
                filter.find('.filterDropdown--label--count').text('0');
                if (filter.find('.filterDropdown--label--count').parent().is(':visible')) {
                    console.log('hide', filter.find('.filterDropdown--label--count').parent());
                    filter.find('.filterDropdown--label--count').parent().hide();
                }
            }
    
            if (!filterBtn.is(':visible')) {
                filterBtn.slideDown();
            }
        });
    });
    
    filterBtn.on('click', function(e) {
        e.preventDefault();
        // filterBtn.slideUp();
    
        // for each filters, get the checked items and add them to the form data object
        const formData = {};
        filters.each(function() {
            const filter = $(this);
            const options = filter.next().find('.tpfl-check').filter(':checked');
            const values = options.map(function() {
                return $(this).val();
            }).get();
            formData[filter.data('filter')] = values;
        }); 
    
        // remove empty filters
        for (const key in formData) {
            if (formData[key].length === 0) {
                delete formData[key];
            }
        }
    
        if (formData) {
            // build the query string and redirect to the new URL
            for (const key in formData) {
                formData[key] = formData[key].join(',');
            }
            window.location.href = form.attr('action') + '?' + $.param(formData);
        } else {
            window.location.href = window.location.href.split('?')[0];
        }  
    });    

    // sort by
    sortBy.on('change', function() {
        const value = $(this).val();
        const url = new URL(window.location.href);
        url.searchParams.set('sort', value);
        window.location.href = url.href;
    });

    // clear filters
    clearFilters.on('click', function(e) {
        e.preventDefault();
        window.location.href = '/catalogue/';
    });

    function mobileFiltersClose(){
        mobileFilters.removeClass('active');
        $('#mobileSidebarFiltersGrad').addClass('hidden');
        $('body').css('overflow', 'auto');
    }

    filtersClose.on('click', function() {
        mobileFiltersClose();
        mobileFiltersBtn.addClass('active');
    });

    openFilters.on('click', function() {
        mobileFilters.css('top', headerHeight);
        mobileFilters.css('height', 'calc(100dvh - ' + headerHeight + 'px)');
        mobileFiltersBtn.removeClass('active');
        mobileFilters.addClass('active');
        $('#mobileSidebarFiltersGrad').removeClass('hidden');
        $('body').css('overflow', 'hidden');
    });

    $('#mobileSidebarFiltersGrad').on('click', function() {
        mobileFiltersClose();
        mobileFiltersBtn.addClass('active');
    });

    // on scroll show the btn if on mobile
    $(window).scroll(function() {
        if ($(window).scrollTop() > 100) {
            if(window.innerWidth < 992 && !(mobileFilters.hasClass('active'))){
                mobileFiltersBtn.addClass('active');
            }
        } else {
            mobileFiltersBtn.removeClass('active');
        }
    });

    // close mobile filters and remove button on resize (or orientation change just to be sure) to web sizes
    function mobileButtonAndFiltersClose(){ 
        if(window.innerWidth > 991){
            $('.cta_archive_filters-v2').removeClass('active');
            mobileFiltersClose();
        }
        else if(!(mobileFilters.hasClass('active'))){
            $('.cta_archive_filters-v2').addClass('active');
        }
    }

    $(window).on('resize', function(){
        // console.log(window.innerWidth);
        mobileButtonAndFiltersClose();
    });

    $(window).on('orientationchange', function(){
        mobileButtonAndFiltersClose();
    });
}